import React, { useEffect, useRef, useState } from 'react'
import profile_icon from '../../assets/img/profile_icon.png';
import { useDispatch, useSelector } from 'react-redux';
import { UserEditprofile, clearData } from '../../store/apiSlice/EditUserProfileSlice';
import { ClipLoader } from 'react-spinners';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Form } from 'react-bootstrap';
import { uploadFile } from '../../store/apiSlice/uploadFileSlice';
import { getUserprofile } from '../../store/apiSlice/UserprofileSlice';
import { capitalizeFirstLetter } from '../../utils/help';
import { requestPhoneChange, verifyPhoneChange, clearChangePhone } from '../../store/apiSlice/ChangePhoneSlice';

const EditUserProfile = () => {
    const dispatch = useDispatch();
    const UserEditData = useSelector((state) => state.rootReducer.UserEditprofileReducer.data);
    const profileData = useSelector((state) => state.rootReducer.UserProfileReducer.data);
    const uploadFileData = useSelector((state) => state.rootReducer.uploadFileReducer.data);
    const changePhoneData = useSelector((state) => state.rootReducer.changePhone);

    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [date, setDate] = useState('');
    const [country, setCountry] = useState('');
    const [profileImage, setProfileImage] = useState('');
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [description, setDescription] = useState('');
    const [pinCode, setPinCode] = useState('');
    const textareaRef = useRef(null);

    // Change phone number state
    const [showPhoneChange, setShowPhoneChange] = useState(false);
    const [newPhone, setNewPhone] = useState('');
    const [newPhoneCountry, setNewPhoneCountry] = useState('34');
    const [phoneOtp, setPhoneOtp] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [phoneUserId, setPhoneUserId] = useState(null);

    // ── Profile update ──
    const updateProfile = () => {
        if (disabled) {
            const payload = {
                firstName: firstName ? capitalizeFirstLetter(firstName) : null,
                lastName: lastName ? capitalizeFirstLetter(lastName) : null,
                dateOfBirth: date,
                address: profileData.data.address,
                profileImage,
                pinCode,
                latitude: profileData.data.latitude,
                longitude: profileData.data.longitude,
                countryCode: profileData.data.countryCode,
                description,
            };
            try {
                dispatch(UserEditprofile(payload));
            } catch (error) {
                console.error('UserEditprofile failed:', error);
            }
        } else {
            setDisabled(true);
        }
    };

    // ── Phone change handlers ──
    const handleSendPhoneOtp = () => {
        if (!newPhone || newPhone.trim() === '') {
            alert('Please enter a new phone number');
            return;
        }
        dispatch(requestPhoneChange({ newMobileNumber: newPhone, newCountryCode: `+${newPhoneCountry}` }));
    };

    const handleVerifyPhoneOtp = () => {
        if (!phoneOtp || phoneOtp.trim() === '') {
            alert('Please enter the OTP');
            return;
        }
        dispatch(verifyPhoneChange({ _id: phoneUserId, otp: phoneOtp, emailVerify: 3 }));
    };

    useEffect(() => {
        if (changePhoneData.requestData) {
            if (changePhoneData.requestData.status === 1) {
                setOtpSent(true);
                alert('OTP sent to your new phone number. Please enter it below.');
            } else {
                alert(changePhoneData.requestData.message || 'Failed to send OTP');
            }
            dispatch(clearChangePhone());
        }
    }, [changePhoneData.requestData]);

    useEffect(() => {
        if (changePhoneData.verifyData) {
            if (changePhoneData.verifyData.status === 1) {
                alert('Phone number updated successfully!');
                setShowPhoneChange(false);
                setOtpSent(false);
                setNewPhone('');
                setPhoneOtp('');
                dispatch(getUserprofile());
            } else {
                alert(changePhoneData.verifyData.message || 'OTP verification failed');
            }
            dispatch(clearChangePhone());
        }
    }, [changePhoneData.verifyData]);

    useEffect(() => {
        if (profileData?.data?._id) setPhoneUserId(profileData.data._id);
    }, [profileData]);

    useEffect(() => {
        if (UserEditData != null && UserEditData.status === 1) {
            setDisabled(false);
            dispatch(getUserprofile());
            dispatch(clearData());
            alert(UserEditData.message);
        } else if (UserEditData != null) {
            alert(UserEditData.message);
        }
    }, [UserEditData]);

    useEffect(() => {
        if (profileData != null && profileData.status === 1) {
            setFirstName(profileData.data.firstName);
            setLastName(profileData.data.lastName);
            setDate(profileData.data.dateOfBirth);
            setEmail(profileData.data.email);
            setPinCode(profileData.data.pinCode);
            setCountry(profileData.data.countryCode);
            setMobileNumber(profileData.data.mobileNumber);
            setProfileImage(profileData.data.profileImage);
            setDescription(profileData.data.description);
        }
    }, [profileData]);

    const handleOnChange = (value, country) => setCountry(country.dialCode);

    useEffect(() => {
        if (uploadFileData != null) {
            setProfileImage(uploadFileData.Location);
            setLoading(false);
        }
    }, [uploadFileData]);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) { alert('Please select a file'); return; }
        setLoading(true);
        dispatch(uploadFile(file));
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="row">

                        {/* Profile image + save button */}
                        <div className="col-12 mb-4 edit_photo">
                            <div className='edit_flex'>
                                <div className="upload-input upload_input_text">
                                    <label htmlFor="upload">
                                        <span><img src={profileImage !== '' ? profileImage : profile_icon} alt="card" /></span>
                                        <span><input type="file" id="upload" style={{ display: 'none' }} onChange={handleFileUpload} /></span>
                                    </label>
                                    <label className="btn_upload ms-3" htmlFor="upload" style={{ color: '#89d6ce' }}>
                                        {disabled ? 'Change Profile Image' : ''}
                                    </label>
                                </div>
                                <button type='button' color="primary" className="profile_button save" onClick={() => updateProfile()}>
                                    {disabled ? (loading ? <ClipLoader size={16} color="#fff" /> : 'SAVE') : 'Edit Profile'}
                                </button>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <form className="w-100 mb-4 pb-2">
                                <Form.Label>First Name</Form.Label>
                                <div className="input-group mb-0">
                                    <input type="text" disabled={!disabled} placeholder="First Name" value={firstName} onChange={(val) => setFirstName(val.target.value)} />
                                </div>
                            </form>
                        </div>

                        <div className="col-md-6">
                            <form className="w-100 mb-4">
                                <Form.Label>Last Name</Form.Label>
                                <div className="input-group mb-0">
                                    <input type="text" disabled={!disabled} placeholder="Last Name" value={lastName} onChange={(val) => setLastName(val.target.value)} />
                                </div>
                            </form>
                        </div>

                        <div className="col-md-6">
                            <form className="w-100 mb-4">
                                <Form.Label>Email</Form.Label>
                                <div className="input-group mb-0">
                                    <input type="text" disabled={true} placeholder="Enter Email" value={email} />
                                </div>
                            </form>
                        </div>

                        <div className="col-md-6">
                            <form>
                                <div className='main_input'>
                                    <div className="input_field_flex">
                                        <Form.Label>Phone Number</Form.Label>
                                        <div className='btn_flex'>
                                            <PhoneInput
                                                disabled={true}
                                                inputClass={"inputt-ph"}
                                                containerStyle={{}}
                                                searchClass="search-class"
                                                disableSearchIcon={false}
                                                enableTerritories
                                                countryCodeEditable={false}
                                                placeholder='Phone Number'
                                                buttonStyle={{ width: '47px' }}
                                                dropdownStyle={{ height: '150px' }}
                                                enableSearch={true}
                                                value={country}
                                                onChange={handleOnChange}
                                                readOnly
                                            />
                                            <input type='number' disabled={true} className='mobilenumber' value={mobileNumber} onChange={(val) => setMobileNumber(val.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div className="col-md-12">
                            <form className="w-100 mb-4" appearance="outline">
                                <Form.Label>About</Form.Label>
                                <div className="input-group mb-0">
                                    <textarea
                                        ref={textareaRef}
                                        disabled={!disabled}
                                        value={description}
                                        onChange={(e) => {
                                            setDescription(e.target.value);
                                            e.target.style.height = 'auto';
                                            e.target.style.height = e.target.scrollHeight + 'px';
                                        }}
                                        rows={3}
                                        style={{ width: '100%', boxSizing: 'border-box', overflow: 'hidden', resize: 'none', padding: 10, borderRadius: 8, outline: 'none', borderColor: '#ddd' }}
                                        placeholder="Type something..."
                                    />
                                </div>
                            </form>
                        </div>

                        {/* ── Change Phone Number ── */}
                        <div className="col-12 mt-2 mb-4">
                            <div style={{ border: '1.5px solid #e8e8e8', borderRadius: '12px', backgroundColor: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>

                                {/* Header */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1.25rem', borderBottom: showPhoneChange ? '1px solid #f0f0f0' : 'none', backgroundColor: '#fafafa', borderRadius: showPhoneChange ? '12px 12px 0 0' : '12px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                                        {/* <span style={{ fontSize: '1.1rem' }}>📱</span> */}
                                        <div>
                                            <h6 style={{ margin: 0, fontWeight: 700, fontSize: '0.95rem', color: '#1a1a1a' }}>Change Phone Number</h6>
                                            {!showPhoneChange && (
                                                <p style={{ margin: 0, fontSize: '0.78rem', color: '#888' }}>
                                                    Current: {profileData?.data?.countryCode} {profileData?.data?.mobileNumber}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => { setShowPhoneChange(!showPhoneChange); setOtpSent(false); setNewPhone(''); setPhoneOtp(''); dispatch(clearChangePhone()); }}
                                        style={{ backgroundColor: showPhoneChange ? '#f5f5f5' : '#89d6ce', color: showPhoneChange ? '#555' : '#fff', border: 'none', borderRadius: '8px', padding: '0.4rem 1.1rem', fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer', transition: 'all 0.2s', whiteSpace: 'nowrap' }}
                                    >
                                        {showPhoneChange ? '✕ Cancel' : 'Change'}
                                    </button>
                                </div>

                                {/* Step 1 — enter new number */}
                                {showPhoneChange && !otpSent && (
                                    <div style={{ padding: '1.25rem', paddingBottom: "200px" }}>
                                        <Form.Label style={{ fontWeight: 600, fontSize: '0.88rem', color: '#444', marginBottom: '0.6rem', display: 'block' }}>
                                            New Phone Number
                                        </Form.Label>
                                        <div style={{ display: 'flex', gap: '0.6rem', alignItems: 'stretch', marginBottom: '1rem', position: 'relative', overflow: 'visible' }}>
                                            <div style={{ flexShrink: 0 }}>
                                                <PhoneInput
                                                    countryCodeEditable={false}
                                                    enableSearch
                                                    disableSearchIcon={false}
                                                    defaultCountry="ES"
                                                    buttonStyle={{ width: '52px', borderRadius: '8px 0 0 8px', border: '1.5px solid #ddd', borderRight: 'none', backgroundColor: '#f8f8f8' }}
                                                    inputStyle={{ width: '110px', height: '44px', borderRadius: '0 8px 8px 0', border: '1.5px solid #ddd', borderLeft: 'none', fontSize: '0.9rem', color: '#555', backgroundColor: '#f8f8f8', cursor: 'default', marginLeft: '0.5rem' }}
                                                    dropdownStyle={{ width: '280px', maxHeight: '200px' }}
                                                    dropdownClass="phone-dropdown-up"
                                                    value={newPhoneCountry}
                                                    onChange={(val) => setNewPhoneCountry(val)}
                                                    inputProps={{ readOnly: true }}
                                                    autoFormat={true}
                                                />
                                            </div>
                                            <input
                                                type="tel"
                                                placeholder="Enter new number"
                                                value={newPhone}
                                                onChange={(e) => setNewPhone(e.target.value.replace(/\D/g, ''))}
                                                style={{ flex: 1, height: '44px', border: '1.5px solid #ddd', borderRadius: '8px', padding: '0 0.9rem', fontSize: '0.95rem', outline: 'none', transition: 'border-color 0.2s', minWidth: 0 }}
                                                onFocus={(e) => e.target.style.borderColor = '#89d6ce'}
                                                onBlur={(e) => e.target.style.borderColor = '#ddd'}
                                            />
                                        </div>
                                        <button
                                            type="button"
                                            onClick={handleSendPhoneOtp}
                                            disabled={changePhoneData.loading}
                                            style={{ backgroundColor: '#89d6ce', color: '#fff', border: 'none', borderRadius: '8px', padding: '0.55rem 1.5rem', fontWeight: 600, fontSize: '0.9rem', cursor: changePhoneData.loading ? 'not-allowed' : 'pointer', opacity: changePhoneData.loading ? 0.75 : 1, display: 'flex', alignItems: 'center', gap: '0.4rem' }}
                                        >
                                            {changePhoneData.loading ? <><ClipLoader size={14} color="#fff" /> Sending…</> : 'Send OTP'}
                                        </button>
                                    </div>
                                )}

                                {/* Step 2 — verify OTP */}
                                {showPhoneChange && otpSent && (
                                    <div style={{ padding: '1.25rem' }}>
                                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', backgroundColor: '#e8f9f4', border: '1px solid #b2e8d8', borderRadius: '20px', padding: '0.3rem 0.9rem', fontSize: '0.82rem', color: '#1a7f4b', marginBottom: '1rem' }}>
                                            OTP sent to <strong>+{newPhoneCountry} {newPhone}</strong>
                                        </div>
                                        <Form.Label style={{ fontWeight: 600, fontSize: '0.88rem', color: '#444', marginBottom: '0.5rem', display: 'block' }}>
                                            Enter the 4-digit OTP
                                        </Form.Label>
                                        <input
                                            type="tel"
                                            placeholder="— — — —"
                                            maxLength={6}
                                            value={phoneOtp}
                                            onChange={(e) => setPhoneOtp(e.target.value.replace(/\D/g, ''))}
                                            style={{ display: 'block', width: '100%', maxWidth: '200px', height: '50px', border: '1.5px solid #ddd', borderRadius: '10px', padding: '0 1rem', fontSize: '1.4rem', letterSpacing: '0.4rem', textAlign: 'center', outline: 'none', marginBottom: '1rem', fontWeight: 700, color: '#1a1a1a' }}
                                            onFocus={(e) => e.target.style.borderColor = '#89d6ce'}
                                            onBlur={(e) => e.target.style.borderColor = '#ddd'}
                                        />
                                        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', alignItems: 'center' }}>
                                            <button
                                                type="button"
                                                onClick={handleVerifyPhoneOtp}
                                                disabled={changePhoneData.loading}
                                                style={{ backgroundColor: '#89d6ce', color: '#fff', border: 'none', borderRadius: '8px', padding: '0.55rem 1.5rem', fontWeight: 600, fontSize: '0.9rem', cursor: changePhoneData.loading ? 'not-allowed' : 'pointer', opacity: changePhoneData.loading ? 0.75 : 1, display: 'flex', alignItems: 'center', gap: '0.4rem' }}
                                            >
                                                {changePhoneData.loading ? <><ClipLoader size={14} color="#fff" /> Verifying…</> : '✔ Verify & Update'}
                                            </button>
                                            <button
                                                type="button"
                                                onClick={handleSendPhoneOtp}
                                                disabled={changePhoneData.loading}
                                                style={{ backgroundColor: 'transparent', color: '#89d6ce', border: '1.5px solid #89d6ce', borderRadius: '8px', padding: '0.5rem 1.1rem', fontWeight: 600, fontSize: '0.85rem', cursor: changePhoneData.loading ? 'not-allowed' : 'pointer' }}
                                            >
                                                Resend OTP
                                            </button>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default EditUserProfile;